import type { ServiceCatalog } from '@/entities/service-catalog';

export type ScheduleSessionServiceOption = {
    code: string;
    description: string;
    label: string;
};

// Uses the practice's configured `catalog.services`, not the published `SERVICE_CODES` list,
// because scheduling picks an existing service rather than adding one to the catalog.
export function getScheduleSessionServiceOptions(
    catalog: Pick<ServiceCatalog, 'services'>,
): ScheduleSessionServiceOption[] {
    return catalog.services
        .map(({ code, description }) => ({ code, description, label: `${code} ${description}` }))
        .sort((a, b) => a.code.localeCompare(b.code));
}
